import React, { useMemo } from 'react';

// Components
import * as S from '../ProductModal/Styled';
import Selecter from '../Selecter';

// Utils
import { isDisabled } from '../../utils/card';
import { replaceStr } from '../../utils';

const FormDropdown = ({ item, changeGroup }) => {
  const items = useMemo(
    () =>
      item.release_forms.map(
        ({ quantity, drugstore_price, online_price, id, name }) => ({
          id,
          title: replaceStr(name, item.goods_name.name),
          disabled: isDisabled({
            quantity,
            drugstore_price,
            online_price,
          }),
        })
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [item]
  );

  return (
    <S.ReleaseForm>
      <Selecter items={items} onSelect={changeGroup} withIcon={false} />
    </S.ReleaseForm>
  );
};

export default FormDropdown;
